import React, { useState } from "react";
import ButtonIconTooltipCompleo from "Components/ButtonIconTooltipCompleo";
import { JobFunnelQuickViewDialog } from "./JobFunnelQuickViewDialog";
import useJobContext from "Pages/Job/JobView/useJobContext";
import InfoIcon from "@material-ui/icons/Info";

export function JobFunnelQuickView() {
    const [open, setOpen] = useState(false);
    const [data, dispatch] = useJobContext();

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const { t } = data;
    if (!data) {
        return null;
    }
    return (
        <>
            <ButtonIconTooltipCompleo
                label={t("quickPipelineView")}
                onClick={handleOpen}
            >
                <InfoIcon />
            </ButtonIconTooltipCompleo>

            {open && (
                <JobFunnelQuickViewDialog open={open} onClose={handleClose} />
            )}
        </>
    );
}
